import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Form from '../../Modules/form/components/Form';
import { Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import Box from '@material-ui/core/Box';
import { selectAllLocations } from '../../Modules/locations/locationsSlice';
import LocationSelect from '../../Modules/form/components/specialized/LocationSelect';
import ProvisionMonthSelect from '../../Modules/form/components/specialized/ProvisionMonthSelect';
import { exportDataRequest } from './hooks';
import LoadingButton from '../Helpers/LoadingButton';
import { selectEmployeesById } from '../../Modules/employees/employeesSlice';
import { useIsFranchise, useGetUserEmplyeeId} from '../../Modules/abilities/hooks';
import { Typography } from '@material-ui/core';

const FORM_KEY = 'export_commission_pre_check_excel';
const EXPORT_TYPE = 'export_commission_pre_check_excel';

const CommissionPreCheckExport_Excel = () => {
    const [loading, setLoading] = useState(false);
    const [errorDownload, setErrorDownload] = useState(null);

    const locations = useSelector(selectAllLocations);
    const isFranchise = useIsFranchise();
    const employeeId = useGetUserEmplyeeId();
    const employees = useSelector(selectEmployeesById);
    const employeeLocations = locations.filter(location => location.id === employees[employeeId].locationId);

    const handleExportSubmit = async (values) => {
        setErrorDownload(null);

        const submitValues = { ...values };
        if (isFranchise && employeeLocations.length > 0) {
            submitValues.location = employeeLocations[0].id;
        }

        const monthDate = new Date(submitValues.provision_month);
        if (isNaN(monthDate)) {
            setErrorDownload(new Error('Ungültiger Monat!'));
            return;
        }

        try {
            setLoading(true);
            await exportDataRequest(EXPORT_TYPE, submitValues);
        } catch (err) {
            errorDownload(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box mt={3}>
            <Card data-cy="card-CommissionPreCheckExport_Excel">
                <h6 className="card-header">Provisionsabrechnung - Vorkontrolle (Excel)</h6>
                <CardBody>
                    <p>
                        Unter folgendem Link kann die Datei für die Provisionsabrechnung (Vorkontrolle) heruntergeladen
                        werden.
                    </p>
                    <Form
                        onSubmit={handleExportSubmit}
                    >
                        <Row>
                            <Col>
                                <ProvisionMonthSelect
                                    name="provision_month"
                                    fullWidth
                                    label="Monat"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Standort:</Label>
                                    {isFranchise ? (
                                    <>
                                        <Typography variant="h4" color="textSecondary">
                                            {employeeLocations[0].name}
                                        </Typography>
                                    </>
                                    ) : (
                                        <>
                                            <LocationSelect
                                                name="location"
                                                label="Standort"
                                                fullWidth
                                            />
                                        </>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <LoadingButton
                                color="primary"
                                id={FORM_KEY}
                                title="Klicken um die Datei herunterzuladen"
                                type="submit"
                                isLoading={loading}
                            >
                                Herunterladen
                            </LoadingButton>
                        </div>
                        {errorDownload && <div className="text-danger">{errorDownload.message}</div>}
                    </Form>
                </CardBody>
            </Card>
        </Box>
    );
};

CommissionPreCheckExport_Excel.propTypes = {

};

CommissionPreCheckExport_Excel.defaultProps = {

};

export default CommissionPreCheckExport_Excel;
